export default {
  items: [
    // { name: 'profile', classIcon: 'mdi mdi-account', to: '/profile', slug: 'profile', },
    // { name: 'organizations', classIcon: 'mdi mdi-city', to: '/organizations', slug: 'organizations', },
  ]
}
